import QuestionRadio from 'app/components/tests/questions/QuestionRadio';
import GoogleAdsense from 'app/components/layouts/Ads/GoogleAdsense';
import * as testConst from 'app/constants/tests';
import { Question } from 'types/test';

interface RadioOptionsProps {
  question: Question;
  groupType: number;
  partId: number | null;
  showAds: boolean;
  confirmIsReady: () => void;
  handleChange: (value: string | null, question: Question) => void
}

const RadioOptions = (props: RadioOptionsProps) => {
  if (props.groupType !== testConst.QUESTION_RADIO) return null;

  return (
    <div className='row'>
      <div className={`col-md-${props.showAds ? '6' : '12'}`}>
        {['A', 'B', 'C', 'D'].map((letter, index: number) => {
          const label = props.question[`answer_${letter.toLowerCase()}` as keyof Question];
          return label && (
            <div key={letter} onClick={() => props.confirmIsReady()} className="d-flex mb-2 pl-2">
              <QuestionRadio
                value={index + 1}
                question={props.question}
                partId={props.partId}
                handleChange={props.handleChange}
                textRadio={letter}
                label={label}
              />
            </div>
          );
        })}
      </div>
      {props.showAds && (
        <div className="col-md-6">
          <GoogleAdsense width="336px" height="280px" dataSlot="4537753411" />
        </div>
      )}
    </div>
  );
};

export default RadioOptions;
